import {
  documentStatusSelectItems,
  importanceStatus_CreteDocument,
} from "~/components/Forms/CreateDocument/utils/utils";
import { FilterField } from "~/features/filter";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы документов: текстовые поля, селекты важности
 * и статуса, диапазон дат создания — всё в одну строку
 * (dateRange с фиксированной шириной).
 */
export const documentsFilterFields = (t: Translate): FilterField[] => [
  {
    name: "name",
    type: "input",
    label: t("documents.card.name"),
  },
  {
    name: "description",
    type: "input",
    label: t("documents.card.description"),
  },
  {
    name: "signedBy",
    type: "input",
    label: t("documents.card.signedBy"),
  },
  {
    name: "importance",
    type: "select",
    label: t("documents.card.importance"),
    options: importanceStatus_CreteDocument,
  },
  {
    name: "status",
    type: "select",
    label: t("documents.card.status"),
    options: documentStatusSelectItems,
  },
  {
    name: "createdAtFrom",
    nameTo: "createdAtTo",
    type: "dateRange",
    label: t("employee.createAt"),
    placeholder: t("pkd.data_begin"),
    placeholderTo: t("pkd.data_end"),
    fixedWidth: 360,
    disableFutureDates: true,
  },
];
